import { render, staticRenderFns } from "./Detalle.vue?vue&type=template&id=6e5f6616&lang=pug"
import script from "./Detalle.vue?vue&type=script&lang=js"
export * from "./Detalle.vue?vue&type=script&lang=js"
import style0 from "./Detalle.vue?vue&type=style&index=0&id=6e5f6616&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports